import { setCookie } from 'ha/modules/Cookies';

const trackFbclid = fbclid => dispatch => {
  if (fbclid) dispatch(setCookie('fbclid', fbclid, { expires: 90 }));
};

export default trackFbclid;
